/** Set when user lands on `/group/:group` (no course). Drives login-first UX + post-login group course picker. */
export const SESSION_GROUP_ONLY_ENTRY = 'trwidget_group_only_entry';
